
import { useState } from "react"
import { Link } from "react-router-dom"
import { Star, ShoppingCart, Heart } from "lucide-react"
import { useCart } from "../../context/cart-context"

export default function ProductCard({ id, name, image, price, originalPrice, rating, reviewCount, discount, isNew }) {
  const [isHovered, setIsHovered] = useState(false)
  const { addToCart } = useCart()

  const handleAddToCart = (e) => {
    e.preventDefault()
    e.stopPropagation()
    addToCart({ id, name, image, price })
  }

  return (
    <Link
      to={`/product/${id}`}
      className="group relative bg-white rounded-lg border border-gray-200 overflow-hidden shadow-sm hover:shadow-md transition-all"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Discount Badge */}
      {discount && (
        <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-md z-10">
          -{discount}%
        </div>
      )}

      {/* New Badge */}
      {isNew && (
        <div className="absolute top-2 left-2 bg-green-500 text-white text-xs font-bold px-2 py-1 rounded-md z-10">
          NEW
        </div>
      )}

      {/* Wishlist Button */}
      <button
        className="absolute top-2 right-2 bg-white p-1.5 rounded-full shadow-sm z-10 text-gray-400 hover:text-red-500 transition-colors"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          // Wishlist functionality would go here
        }}
      >
        <Heart size={18} />
      </button>

      {/* Product Image */}
      <div className="relative h-48 overflow-hidden">
        <img
          src={image || "/placeholder.svg"}
          alt={name}
          className={`w-full h-full object-cover transition-transform duration-300 ${isHovered ? "scale-110" : "scale-100"}`}
        />

        {/* Quick Add Button - Shows on hover */}
        <div
          className={`absolute bottom-0 left-0 right-0 bg-white/90 py-2 px-3 transition-transform duration-300 ${
            isHovered ? "translate-y-0" : "translate-y-full"
          }`}
        >
          <button
            className="w-full bg-[#ff9906] hover:bg-[#e68a00] text-white py-1.5 rounded-md flex items-center justify-center gap-1 text-sm font-medium transition-colors"
            onClick={handleAddToCart}
          >
            <ShoppingCart size={16} />
            Add to Cart
          </button>
        </div>
      </div>

      {/* Product Info */}
      <div className="p-4">
        <h3 className="text-sm font-medium text-gray-800 line-clamp-2 min-h-[40px]">{name}</h3>

        {/* Price */}
        <div className="mt-2 flex items-center">
          <span className="text-[#ff9906] font-bold">${price.toFixed(2)}</span>
          {originalPrice && (
            <span className="ml-2 text-gray-400 text-sm line-through">${originalPrice.toFixed(2)}</span>
          )}
        </div>

        {/* Rating */}
        <div className="mt-2 flex items-center">
          <div className="flex items-center">
            {[...Array(5)].map((_, i) => (
              <Star
                key={i}
                size={14}
                className={i < Math.floor(rating) ? "fill-[#ff9906] text-[#ff9906]" : "text-gray-300"}
              />
            ))}
          </div>
          <span className="ml-1 text-xs text-gray-500">({reviewCount})</span>
        </div>
      </div>
    </Link>
  )
}
